import { useEffect, useState } from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { layoutOf, useLayoutFonts, cssVars, waUrl } from "@/components/demo/layouts";
import { DemoHero } from "@/components/demo/DemoHero";
import { WhyCome, Dishes, Carta, Gallery, Reviews, Title } from "@/components/demo/DemoSections";
import { DemoReservation, DemoInfo, DZ_FIELD } from "@/components/demo/DemoReservation";
import { QuoteRequestForm } from "@/components/site/QuoteRequestForm";
import "@/components/demo/demo.css";

const DZ_QUOTE_UI = { card: "dz-card shadow-sm", field: DZ_FIELD, muted: "opacity-70", accentText: "text-[var(--p)]", button: "dz-btn bg-[var(--p)] text-white" };

function StickyWhatsapp({ n }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  if (!n) return null;
  return (
    <a href={waUrl(n)} target="_blank" rel="noreferrer" aria-label="WhatsApp" data-testid="sticky-whatsapp-btn"
      className={`dz-fab fixed bottom-5 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl ${show ? "opacity-100" : "pointer-events-none translate-y-4 opacity-0"}`}>
      <WhatsappLogo size={30} weight="fill" />
    </a>
  );
}

/** Same design for the demo and for the official site the client receives after conversion. */
export function DemoPage({ s: raw, official = false, slug }) {
  const s = { ...raw,
    booking: official ? raw.contact_mode === "reservas" : raw.demo_reservations,
    quote: official ? raw.contact_mode === "orcamento" : raw.demo_quote };
  const L = layoutOf(s.layout);
  useLayoutFonts(L);
  return (
    <div className={`dz min-h-screen ${L.dark ? "dz-dark" : ""}`} style={cssVars(L, s.palette)} data-testid={official ? "official-site" : "demo-site"} data-layout={s.layout}>
      {!official && (
        <div className="fixed inset-x-0 top-0 z-50 bg-black/55 py-1.5 text-center text-[11px] font-medium tracking-wide text-white backdrop-blur-md" data-testid="demo-banner">
          Demonstração criada por GestaCV — Tavares Groupe
        </div>
      )}
      <DemoHero s={s} L={L} />
      <main className="mx-auto max-w-3xl">
        <WhyCome items={s.why_come} />
        <Dishes dishes={s.dishes} />
        <Gallery items={s.gallery_meta} />
        <Reviews s={s} />
        <Carta menu={s.menu} source={s.menu_source} note={!official && s.menu_note} />
        <DemoReservation s={s} official={official} slug={slug} />
        {s.quote && (
          <section id="orcamento" className="scroll-mt-10 px-6 py-14" data-testid="quote-section">
            <Title kicker="Orçamentos">Pedir orçamento</Title>
            <QuoteRequestForm slug={slug} ui={DZ_QUOTE_UI} disabled={!official} />
          </section>
        )}
        <DemoInfo s={s} />
        <footer className="px-6 pb-24 pt-6 text-center text-xs" style={{ color: "var(--muted)" }}>
          © {new Date().getFullYear()} {s.name}{official ? " · Site criado com GestaCV" : " · Demonstração criada por GestaCV"}
          {s.from_google ? " · Fotos, nota e avaliações via Google" : ""}
        </footer>
      </main>
      <StickyWhatsapp n={s.whatsapp} />
    </div>
  );
}
